import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { useAuth } from "../../Services/Context/AuthContext";
import { useDarkMode } from "../../Services/Context/DarkModeContext";
import AuthModal from "../Auth/AuthModal";
import TosGate from "../Auth/TosGate";
import "./UserButton.css";
import { useUtilImages } from "../../Services/Hooks/useUtilImages";

const UserButton = () => {
  const { user, tosAccepted, signOut } = useAuth();
  const { dark } = useDarkMode();
  const [showMenu, setShowMenu] = useState(false);
  const [isMenuClosing, setIsMenuClosing] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { down } = useUtilImages();

  const closeMenu = () => {
    setIsMenuClosing(true);
    setTimeout(() => {
      setShowMenu(false);
      setIsMenuClosing(false);
    }, 200);
  };

  const handleIconClick = () => {
    if (showMenu) {
      closeMenu();
    } else {
      setIsMenuClosing(false);
      setShowMenu(true);
    }
  };

  const handleSignOut = async () => {
    closeMenu();
    await signOut();
  };

  if (!user) {
    return (
      <>
        <button
          className={`UserButton-signin ${dark ? "UserButton-signin--dark" : ""}`}
          onClick={() => setShowAuthModal(true)}
        >
          Sign In
        </button>

        <AnimatePresence>
          {showAuthModal && (
            <AuthModal onClose={() => setShowAuthModal(false)} />
          )}
        </AnimatePresence>
      </>
    );
  }

  if (!tosAccepted) return <TosGate />;

  const initial = (user.email ?? user.id).charAt(0).toUpperCase();

  return (
    <div className="UserButton-container">
      {showMenu && (
        <nav
          className={`${dark ? "UserButton-menu--dark" : "UserButton-menu"} animate__animated animate__fadeInUpBig ${isMenuClosing ? "animate__fadeOut" : ""}`}
        >
          <div className="UserButton-menu-sigil">✦</div>
          <div className="UserButton-email">{user.email ?? "Account"}</div>
          <div className="UserButton-divider" />
          <button className="UserButton-signout" onClick={handleSignOut}>
            Sign Out
          </button>
          <button
            className="UserButton-close"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            <img className="Menu-down-button" src={down} alt="close menu" />
          </button>
        </nav>
      )}

      <button
        className={`UserButton-icon ${dark ? "UserButton-icon--dark" : ""}`}
        onClick={handleIconClick}
        aria-label="Account menu"
      >
        {initial}
      </button>
    </div>
  );
};

export default UserButton;
